import { dispatch } from '@angular-redux/store';
import { AccountsModel } from 'sharedFeatures/sharedModels/xero/accountsModel';
import { BaseAction } from './baseAction';

export class xeroSettingsActions {

    static readonly SET_XERO_PLACCOUNTS = 'SET_XERO_PLACCOUNTS';
    static readonly SET_XERO_BSACCOUNTS = 'SET_XERO_BSACCOUNTS';

    @dispatch()
    public static setXeroPLAccounts(accounts: AccountsModel): BaseAction {
        return { type: this.SET_XERO_PLACCOUNTS, payload: accounts };
    }

    @dispatch()
    public static setXeroBSAccounts(accounts: AccountsModel): BaseAction {
        return { type: this.SET_XERO_BSACCOUNTS, payload: accounts };
    }
}
